// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { RootState } from '~/utils/redux/store';
import { createVenue, deleteVenue, getDetailVenue, getListVenue, editVenue } from './venueThunk';

export interface IVenueState {
  isLoading: boolean;
  isRefreshVenueList: boolean;
}

export const initialState: IVenueState = {
  isLoading: false,
  isRefreshVenueList: false,
};

const venueSlice = createSlice({
  name: 'venue',
  initialState,
  reducers: {
    setRefreshVenueList(state, action) {
      state.isRefreshVenueList = action.payload;
    },
  },
  extraReducers(builder) {
    // GET: Get list venue
    builder
      .addCase(getListVenue.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getListVenue.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(getListVenue.rejected, (state) => {
        state.isLoading = false;
      });

    // GET: Get detail venue
    builder
      .addCase(getDetailVenue.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getDetailVenue.fulfilled, (state) => {
        state.isLoading = false;
      })
      .addCase(getDetailVenue.rejected, (state) => {
        state.isLoading = false;
      });

    // POST: Create venue
    builder
      .addCase(createVenue.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(createVenue.fulfilled, (state) => {
        state.isLoading = false;
        state.isRefreshVenueList = true;
      })
      .addCase(createVenue.rejected, (state) => {
        state.isLoading = false;
      });

    // DELETE: Delete venue
    builder
      .addCase(deleteVenue.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteVenue.fulfilled, (state) => {
        state.isLoading = false;
        state.isRefreshVenueList = true;
      })
      .addCase(deleteVenue.rejected, (state) => {
        state.isLoading = false;
      });

    // PUT: Edit venue
    builder
      .addCase(editVenue.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(editVenue.fulfilled, (state) => {
        state.isLoading = false;
        state.isRefreshVenueList = true;
      })
      .addCase(editVenue.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

// Action
export const venueActions = venueSlice.actions;

// Selectors
export const selectIsRefreshListVenue = (state: RootState) => state.venue.isRefreshVenueList;

// Reducer
const venueReducer = venueSlice.reducer;
export default venueReducer;
